<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'app',
  data () {
    return {};
  }
};
</script>
<style lang="scss">
*{
  box-sizing: border-box !important;
}
html,body{
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-family: PingFang SC, Avenir-Heavy, Helvetica Neue, Arial, sans-serif;
  overflow: hidden;
  #app{
    height: 100%;
    width: 100%;
    transform-origin: 0px 0px 0px;
    //background: url(./assets/images/mapbg.jpg) no-repeat;
    //background-size: cover;
    //background-position: 50% 0;
  }
}
/*webkit内核*/
::-webkit-scrollbar {
  width: px2vw(10);
}

::-webkit-scrollbar-track {
  width: px2vw(8);
  background-color: rgba(8, 9, 88, 0.4);
  border-radius: 100px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 100px;
}

.card-wrapper{
  position: relative;
  border: 1px solid rgba(15, 159, 246, 0.3);
  background-color: rgba(4, 5, 56, 0.35);
  &:before,&:after{
    content: '';
    width: px2vw(10);
    height: px2vh(10);
    position: absolute;
    bottom: px2vh(-1);
    border-style: solid;
    border-color: #3BD1FF;
  }
  &:before{
    left: px2vw(-1);
    border-width: 0 0 px2vw(2) px2vw(2);
    box-shadow: -2px 1px 2px 0px #3bd1ff54;
  }
  &:after{
    right: px2vw(-2);
    border-width: 0 px2vw(2) px2vw(2) 0;
    box-shadow: 2px 1px 2px 0px #3bd1ff54;
  }
  .card-title{
    width: auto;
    height: px2vh(59);
    font-size: px2vh(24);
    color: #ffffff;
    background-image: url("./assets/images/transport/title-bg-line.png");
    background-repeat: no-repeat;
    background-size: px2vw(373) px2vh(2);
    .icon{
      width: px2vw(44);
      height: px2vh(44);
    }
    &:before,&:after{
      content: '';
      width: px2vw(10);
      height: px2vh(10);
      position: absolute;
      top: px2vh(-1);
      border-style: solid;
      border-color: #3BD1FF;
    }
    &:before{
      left: px2vw(-1);
      border-width: px2vw(2) 0 0 px2vw(2);
      box-shadow: -2px -1px 2px 0px #3bd1ff54;
    }
    &:after{
      right: px2vw(-2);
      border-width: px2vw(2) px2vw(2) 0 0;
      box-shadow: 2px -1px 2px 0px #3bd1ff54;
    }
  }
}
.v-modal{
  opacity: 0.75 !important;
}
// 数据分析页面，3D地图tooltip自定义样式
.custom-tooltip{
  width: px2vw(582);
  height: px2vh(145);
  background: url("./assets/images/affairs/tooltip-bg.png") no-repeat 0 0;
  background-size: 100% 100%;
  padding-left: px2vw(112);
  padding-top: px2vh(40);
  color: #ffffff;
  .amount{
    margin-top: px2vh(24);
    font-size: px2vh(36);
    font-weight: bold;
    color: #12E6FF;
  }
}
</style>
